export const Chips = ({ options, value, onChange, testPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => {
      const active = value === o;
      return (
        <button type="button" key={o} onClick={() => onChange(o)}
          data-testid={`${testPrefix}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`px-4 py-2 rounded-full border text-sm font-medium transition-[background-color,transform,color] hover:-translate-y-0.5 ${active
            ? "bg-[var(--green)] text-[var(--cream)] border-[var(--green)]"
            : "bg-white border-[var(--line)] hover:border-[var(--green)]"}`}>
          {o}
        </button>
      );
    })}
  </div>
);
